import { render } from "./StudentDetailPage.vue?vue&type=template&id=eadaad12&scoped=true"
import script from "./StudentDetailPage.vue?vue&type=script&lang=js"
export * from "./StudentDetailPage.vue?vue&type=script&lang=js"

import "./StudentDetailPage.vue?vue&type=style&index=0&id=eadaad12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eadaad12"]])

export default __exports__